/** Default cap (px) aligned with DS-6 list table `max-h-[900px]`. */
export const DATA_TABLE_DEFAULT_VIEWPORT_MAX_HEIGHT_PX = 900;

/** Parses `number` as px or strings like `900px` or `16rem`; unknown strings fall back to `defaultPx`. */
export function parseViewportLengthToPx(value: string | number | undefined, defaultPx: number): number {
    if (value === undefined) {
        return defaultPx;
    }
    if (typeof value === 'number') {
        return value;
    }
    const trimmed = value.trim();
    const pxMatch = /^([\d.]+)\s*px$/i.exec(trimmed);
    if (pxMatch) {
        return Math.round(Number.parseFloat(pxMatch[1]));
    }
    const remMatch = /^([\d.]+)\s*rem$/i.exec(trimmed);
    if (remMatch) {
        const rem = Number.parseFloat(remMatch[1]);
        if (!Number.isNaN(rem)) {
            return Math.round(rem * 16);
        }
    }
    return defaultPx;
}
